export default __webpack_public_path__ + "static/media/migdal.a35d2cbf.png";